import { Box, styled } from '@mui/material';
import { theme } from 'src/assets/theme/theme';
export const StyledEmptyStateContainer = styled(Box)`
  margin-top: ${theme.spacing(12.5)};
`;
